import script from "./ManageOrganizationsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageOrganizationsView.vue?vue&type=script&setup=true&lang=ts"

import "./ManageOrganizationsView.vue?vue&type=style&index=0&id=3d30f2ae&lang=scss"

const __exports__ = script;

export default __exports__